// extracted by mini-css-extract-plugin
export default {"containprod":"qE","containprod2":"rE","title":"sE","servings":"tE","recommendation":"uE","image":"vE","flavorswrap":"wE","flavorsgroupwrap":"xE","moredetailsWrap":"yE","infoWrap":"zE","price":"AE","regularPrice":"BE","netPrice":"CE","addtocartcontainer":"EE","error":"FE"};
    if(module.hot) {
      // 1714654893374
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  